import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "flex items-center"
};
const _hoisted_2 = {
  class: "-mx-2"
};
import { CompetitionPlayerLogQueryOrder } from "@/modules/competitions/services/query-paginator/CompetitionPlayerLogQueryOrder";
import { CompetitionPlayerLog, LeagueDivision } from "@/modules/competitions/entity";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import Flag from "@/modules/vue/components/Flag.vue";
import Submenu from "./Submenu";
import ActionButton from "./ActionButton.vue";
import { onBeforeRouteLeave } from "vue-router";
import QueryPaginator from "@/modules/vue/components/QueryPaginator.vue";
import PlayerComponent from "@/modules/team/components/Player.vue";
import CompetitionLogTable from "@/modules/team/pages/players/CompetitionLogTable.vue";
import Talent from "@/modules/youth/components/Talent.vue";
import { Season } from "@/modules/season/entity";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerCompetitionLogs',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const division = ref();
    const query = ref();
    const season = ref(([__temp, __restore] = _withAsyncContext(() => Season.current()), __temp = await __temp, __restore(), __temp));
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      division.value = await LeagueDivision.createQueryBuilder('division').innerJoinAndSelect('division.competition', 'competition').innerJoinAndSelect('competition.country', 'country').innerJoinAndSelect('competition.divisions', 'competitionDivision').innerJoinAndSelect('division.promotions', 'promotion').innerJoinAndSelect('division.stats', 'stats').innerJoinAndSelect('stats.division', 'division2').innerJoinAndSelect('stats.team', 'team').innerJoin('stats.season', 'season').where('season.id = :seasonId', {
        seasonId: season.value.id
      }).andWhere('division.id = :id', {
        id: route.params.id
      }).getOneOrFail();
      query.value = CompetitionPlayerLog.createQueryBuilder('log').innerJoinAndSelect('log.player', 'player').innerJoinAndSelect('player.country', 'country').innerJoin('player.team', 'team').innerJoin('log.season', 'season').where('season.id = :seasonId', {
        seasonId: season.value.id
      }).andWhere(`team.id IN (${division.value.teamIds.join(',')})`);
    })), __temp = await __temp, __restore(), __temp);
    onBeforeRouteLeave(watch(() => route.params, refresh));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [division.value.competition.country ? (_openBlock(), _createBlock(Flag, {
          key: 0,
          country: division.value.competition.country,
          class: "mr-2"
        }, null, 8, ["country"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(division.value.name), 1)])]),
        subtitle: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$date(season.value.startDate, 'YYYY')) + "/" + _toDisplayString(_ctx.$date(season.value.endDate, 'YYYY')), 1)]),
        submenu: _withCtx(() => [_createVNode(_unref(Submenu), {
          "has-table": ""
        })]),
        actionButton: _withCtx(() => [_createVNode(ActionButton, {
          division: division.value,
          divisions: division.value.competition.divisions
        }, null, 8, ["division", "divisions"])]),
        default: _withCtx(() => [_createVNode(QueryPaginator, {
          ref: "paginator",
          query: query.value,
          order: _unref(CompetitionPlayerLogQueryOrder)
        }, {
          default: _withCtx(({
            items,
            currentPage,
            perPage
          }) => [_createElementVNode("div", _hoisted_2, [_createVNode(CompetitionLogTable, {
            stats: items,
            "hide-date": "",
            "start-rank": (currentPage - 1) * perPage + 1,
            class: "mt-2"
          }, {
            label: _withCtx(({
              log
            }) => [_createVNode(Talent, {
              talent: log.player.revealedTalent,
              class: "mr-1"
            }, null, 8, ["talent"]), _createVNode(PlayerComponent, {
              player: log.player,
              "hide-constitution": "",
              class: "grow"
            }, null, 8, ["player"])]),
            _: 2
          }, 1032, ["stats", "start-rank"])])]),
          _: 1
        }, 8, ["query", "order"])]),
        _: 1
      });
    };
  }
});